export default __webpack_public_path__ + "static/media/step4.85e35050.png";